var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TagSelector',{attrs:{"multiple":_vm.multiple,"items":_vm.submissionForms,"value":_vm.value,"rules":_vm.rules},on:{"input":function($event){_vm.$emit('input', $event);
    _vm.$emit('changed', $event);}}})}
var staticRenderFns = []

export { render, staticRenderFns }